
<kendo-grid [kendoGridBinding]="dataSource"
            [resizable]="resizable"
            [pageSize]="pageSize"
            [pageable]="pageable"
            [hideHeader]="hideHeader">
    <kendo-grid-column *ngFor="let col of columns"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col.width"
                       [filter]="col.filter"
                       [sortable]="col.sortable"
                       [groupable]="col.groupable"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format"
                       [style]="col.style"
                       [class]="col.class">

        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <ng-container [ngSwitch]="col.columnType">

                <!-- Link case -->
                <ng-container *ngSwitchCase="'link'">
                    <span class="routerLink-column">
                        <a [routerLink]="['/' + pathUrl, dataItem[dataKey]]" [attr.target]="col.target">
                            {{dataItem[col.field]}}
                        </a>
                    </span>
                </ng-container>

                <!-- Numeric case -->
                <ng-container *ngSwitchCase="'numeric'">
                    <span>{{ dataItem[col.field] | kendoNumber: '#,##0' }}</span>
                </ng-container>

                <!-- Button case -->
                <ng-container *ngSwitchCase="'button'">
                    <ng-container *ngTemplateOutlet="buttonTemplates[col.field]; context: { dataItem: dataItem }">
                    </ng-container>
                </ng-container>

                <!-- Decimal case -->
                <ng-container *ngSwitchCase="'decimal'">
                    <span>{{ dataItem[col.field] | kendoNumber: '#,##0.00' }}</span>
                </ng-container>

                <!-- Date case -->
                <ng-container *ngSwitchCase="'date'">
                    <span>{{ dataItem[col.field] | kendoDate: 'd' }}</span>
                </ng-container>

                <!-- DateTime case -->
                <ng-container *ngSwitchCase="'date-time'">
                    <span>{{ dataItem[col.field] | kendoDate: 'g' }}</span>
                </ng-container>

                <!-- Time case -->
                <ng-container *ngSwitchCase="'time'">
                    <span>{{ dataItem[col.field] | kendoDate: 'HH:mm' }}</span>
                </ng-container>

                <!-- checkbox case -->
                <ng-container *ngSwitchCase="'checkbox'">
                    <kendo-svg-icon *ngIf="dataItem[col.field]" [icon]="checkOutlineIcon" themeColor="success" size="large"></kendo-svg-icon>
                    <kendo-svg-icon *ngIf="!dataItem[col.field]" [icon]="minusOutlineIcon" themeColor="error" size="large"></kendo-svg-icon>
                </ng-container>

                <!-- Switch case -->
                <ng-container *ngSwitchCase="'switch'">
                    <span>
                        <kendo-switch [readonly]="true" [checked]="dataItem[col.field]"
                                      [size]="'small'" [onLabel]="''" [offLabel]="''">
                        </kendo-switch>
                    </span>
                </ng-container>

                <!-- Default case -->
                <ng-container *ngSwitchDefault>
                    <span>{{ dataItem[col.field] }}</span>
                </ng-container>
            </ng-container>
        </ng-template>
    </kendo-grid-column>
</kendo-grid>
